module.exports = __webpack_public_path__ + "img/money_bag.64eb16d6.svg";